import Vue from 'vue'
import FreshVueFiles from '@freshsolutions/fresh-vue-cards'
import i18n from './i18n'

Vue.use(FreshVueFiles, {
  i18n: i18n
})
